import * as React from "react";
import { playAudioForSuccess } from "../../../helpers/playAudioForSuccess";
import { recordOrderProductionJobBoxLocationMutation } from "../../../graph";
import { recordStockContainerLocationMutation } from "../../../graph";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { useRouter } from "found";
import { useState } from "react";
import BarcodeReader from "react-barcode-reader";
import PendingStatusView from "../../../components/PendingStatusView";
import TabbedAppBar from "../../../components/TabbedAppBar";
import Typography from "@mui/material/Typography";
import withBarcodePivot from "../../../components/BarcodePivot/withBarcodePivot";
import withSnackbar from "../../../components/withSnackbar";

const BulkBoxLocationSetterApp = ({
  appBarBackgroundColor,
  backUrl,
  setGlobalBarcodeReaderEnabled,
  showErrorSnackbar,
  showSuccessSnackbar
}) => {
  const { router } = useRouter();

  useEffect(() => {
    setGlobalBarcodeReaderEnabled(false);
    return () => setGlobalBarcodeReaderEnabled(true);
  }, [setGlobalBarcodeReaderEnabled]);

  // Mutations:
  const [recordOrderProductionJobBoxLocation] = useMutation(
    recordOrderProductionJobBoxLocationMutation
  );
  const [recordStockContainerLocation] = useMutation(
    recordStockContainerLocationMutation
  );

  // States:
  const [isLoading, setIsLoading] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);

  // Handlers:
  const handleAppHeaderRequestBack = () => router.push(backUrl || "/apps");

  const handleBarcodeError = () => {
    showErrorSnackbar("Error scanning barcode");
    setIsLoading(false);
  };

  const handleBarcodeScan = barcode => {
    console.log("App Barcode Scan");
    try {
      const data = JSON.parse(barcode);
      const { variant, type, id, name } = data;
      if (variant === "LOCATION" && type.toLowerCase() === "box" && name) {
        setCurrentLocation(name);
      } else if (variant === "OBJECT" && type === "StockContainer" && id) {
        if (!currentLocation) {
          showErrorSnackbar("No Location Set");
          return;
        }
        setIsLoading(true);
        recordStockContainerLocation({
          variables: { location: currentLocation, stockContainerId: id }
        })
          .then(
            ({
              data: {
                recordStockContainerLocation: { succeeded, errors }
              }
            }) => {
              if (succeeded) {
                showSuccessSnackbar("Box location has been recorded.");
                playAudioForSuccess();
              } else {
                showErrorSnackbar(errors.stockContainerId.join(", "));
              }
            }
          )
          .catch(e => {
            showErrorSnackbar(e.message);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else if (variant === "OBJECT" && type === "OrderProductionJob" && id) {
        recordOrderProductionJobBoxLocation({
          variables: { location: currentLocation, orderProductionJobId: id }
        })
          .then(
            ({
              data: {
                recordOrderProductionJobBoxLocation: { succeeded, errors }
              }
            }) => {
              if (succeeded) {
                showSuccessSnackbar(
                  "Order production job box location has been recorded."
                );
                playAudioForSuccess();
              } else {
                showErrorSnackbar(errors.orderProductionJobId.join(", "));
              }
            }
          )
          .catch(e => {
            showErrorSnackbar(e.message);
          });
      }
    } catch {
      setIsLoading(false);
      showErrorSnackbar("Error Scanning Barcode");
    }
  };

  return (
    <div>
      <TabbedAppBar
        title="Bulk Box Location Setter"
        onRequestBack={handleAppHeaderRequestBack}
        appBarBackgroundColor={appBarBackgroundColor}
      />
      {isLoading ? (
        <PendingStatusView status="Loading" />
      ) : (
        <div>
          <BarcodeReader
            onError={handleBarcodeError}
            onScan={handleBarcodeScan}
          />
          {currentLocation && (
            <Typography
              variant="h6"
              align="center"
              color="inherit"
              style={{ flexGrow: 1, marginTop: "10em" }}
            >
              Current Location: {currentLocation}
              <br />
              Scan Container or new location
            </Typography>
          )}
          {!currentLocation && (
            <Typography
              variant="h6"
              align="center"
              color="inherit"
              style={{ flexGrow: 1, marginTop: "10em" }}
            >
              Scan Location
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default withBarcodePivot(withSnackbar(BulkBoxLocationSetterApp));
